"use strict";


App.Pages.Main = class Main extends PF.Page
{

	static get options()
	{
		return {
			rights: {
				user: true,
				client: true,
			},
			panel: false,
			path: '/main',
			nameRu: 'Главная',
		};
	}

	static get template()
	{
		//language=HTML
		return `
			<div id="Main" data-page="Main" class="page navbar-fixed">


				<div class="page-content">

					<div class="page-header">
						<h3>Главная</h3>
					</div>
					
					<div class="stretch-block">

						<div class="pf-button-toggle row resizable" pf="wrapper" style="padding-bottom: 16px">
							<div class="segmented segmented-raised col-30" pf="ul">
								<button class="button button-active" type="button" pf="button1">Карта</button>
								<button class="button" type="button" pf="button2">список</button>
							</div>
						</div>


						<div class="content" pf="mapContent" style="height: 75vh; position: relative">
							<button style="position:absolute;z-index:10; top: 120px; left:10px; height: 40px; width: 40px" class="button button-fill" pf="zoomIn">
								<i class="material-icons" style="line-height:40px">zoom_in</i>
							</button>
							<button style="position:absolute;z-index:10; top: 180px; left:10px; height: 40px; width: 40px" class="button button-fill" pf="zoomOut">
								<i class="material-icons" style="line-height:40px">zoom_out</i>
							</button>


							<div pf="map" style="width: 100%; height:100%; overflow: hidden">

							</div>
						</div>

						<div class="content card" pf="listContent" style="margin:0;">
							<div class="list" pf="list"></div>
						</div>
					</div>

				</div>

			</div>
		`;


	}

	init()
	{
		super.init();

		this.state = 'map';
		this.dom.button1.on('click', () =>
		{
			this.state = 'map';
		});
		this.dom.button2.on('click', () =>
		{
			this.state = 'list';
		});
		this.bindDom({ mapContent: 'show', listContent: 'hide' }, 'state', (s) => s === 'map');
		this.bindDom({ button1: 'class:button-active' }, 'state', (s) => s === 'map');
		this.bindDom({ button2: 'class:button-active' }, 'state', (s) => s === 'list');


		this.stellas = new PF.Models({
			represent: 'stella/manage',
		});


		ymaps.ready(() =>
		{
			this.map = new ymaps.Map(this.dom.map.node, {
				center: app.mapConfig.defaultCenter,
				zoom: app.mapConfig.defaultZoom,
				// ...app.mapConfig
				controls: ['fullscreenControl', 'typeSelector', 'geolocationControl', 'rulerControl'],
				// controls: []
			}, {
				maxZoom: 23
			});

			this.dom.zoomIn.on('click', () =>
			{
				this.map.setZoom(this.map.getZoom() + 1);
			});
			this.dom.zoomOut.on('click', () =>
			{
				this.map.setZoom(this.map.getZoom() - 1);
			});

			this.camerasList = new PF.Map.PointsList({
				map: this.map,
				models: this.stellas,
				itemClass: StellaPoint,
			});

		});

		this.list = new PF.List({
			dom: {
				element: this.dom.list,
				scrollTarget: this.dom.pageContent,
			},
			title: 'Список стелл',
			searchable: true,
			models: this.stellas,
			itemClass: StellaItem,
			searchConfig: ' @{name} ~ @{list.searchField} || @{address} ~ @{list.searchField} || @{serverVa.ip} ~ @{list.searchField}'

		});
	}
};

class StellaPoint extends PF.Map.PointsList.Item
{
	onRender()
	{
		let status = this.model.serverVa.status
		let status_detail = JSON.parse(this.model.serverVa.status_detail)
		this.model.conditionFormatted = '<br>Состояние: ' + this.model.serverVa.condition.name;
		let presetIslands = this.model.serverVa.presetIslands;
		if (status == '200')
		{
			this.model.statusFormatted = '<br>Статус: ' + this.model.serverVa.statusFormatted + ' ' + status_detail.dt;
		} else if (status == '400')
		{
			this.model.statusFormatted = '<br>Статус: ' + this.model.serverVa.statusFormatted + ' ' + status_detail.dt;
		} else if (status == 'set')
		{
			this.model.statusFormatted = '';
		} else if (status == 'default')
		{
			this.model.statusFormatted = '';
		} else if (status == 'off')
		{
			this.model.statusFormatted = '';
		} else 
		{
			this.model.statusFormatted = '<br>Статус: ' + this.model.serverVa.statusFormatted + ' ' + status_detail.dt;
		}


		this.stellaPoint = new ymaps.Placemark(
			[this.model.lat, this.model.lng], {
			hintContent: 'Стела: ' + this.model.name + this.model.conditionFormatted + this.model.statusFormatted,
		}, {
			preset: presetIslands,
			iconImageSize: [10, 10],
			draggable: false,
			zIndex: 1,
			zIndexHover: 1,
		}
		);
		this.list.map.geoObjects.add(this.stellaPoint);


		this.stellaPoint.events.add('click', () =>
		{
			app.pageParams.setData('id', this.model.id);
			app.router.navigate('/stat-stella');
		});
	}
}


class StellaItem extends PF.List.Item
{
	get renderer()
	{
		//language=HTML
		return /*html*/`
			<li pf="item">
				<a href="" class=" item-content item-link" pf="link">
					<div class="item-inner">
						<div class="item-title">
							@{model.name} | <span pf="serverStatus"> @{model.serverVa.condition.name} </span><br/>
							@{model.address}
						</div>
						<div class="item-after">
							<span>@{model.district.name}<br/>
								@{model.serverVa.ip}
							</span>
						</div>
					</div>
				</a>
			</li>
		`;
	}

	onRender()
	{
		super.onRender();
		this.bindDom({ serverStatus: "css:color" }, 'model.serverVa.statusColor');

		this.dom.link.on("click", () =>
		{
			app.pageParams.setData('id', this.model.id);
			app.router.navigate('/stat-stella');
		});
	}

}